var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":"Sort","placement":"top","effect":"light"}},[_c('span',{staticClass:"cursor-pointer",attrs:{"test-id":"sort"},on:{"click":function($event){return _vm.handleSort(_vm.sortItem)}}},[_c('sort-icon',{attrs:{"sort-direction":_vm.sortDirection[_vm.sortItem]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }